import { Action } from 'redux'
import { PriceGridAction } from '../../reducers/price/actionNames'

export interface IRequestPrices extends Action {
  selectedRooms?: number[]
}

const requestPrices = (selectedRooms?): IRequestPrices => {
  return {
    selectedRooms,
    type: PriceGridAction.RequestPrices,
  }
}

export default requestPrices
